const BASE = '/art/'

function url(name: string): string {
  return `${BASE}${name}.webp`
}

export const CHARACTER_ART: Record<string, string> = {
  default_hero: url('char_ember'),
  tiny_blue: url('char_velocity'),
  chonky_green: url('char_guardian'),
  sleek_purple: url('char_mystic'),
  golden_glow: url('char_luminary'),
  aurora_luminary: url('char_aurora_luminary'),
  keeper: url('char_keeper'),
}

export function characterArt(id: string): string | undefined {
  return CHARACTER_ART[id]
}

export const CHARACTER_SPRITE: Record<string, string> = {
  default_hero: url('charsprite_ember'),
  tiny_blue: url('charsprite_velocity'),
  chonky_green: url('charsprite_guardian'),
  sleek_purple: url('charsprite_mystic'),
  golden_glow: url('charsprite_luminary'),
  aurora_luminary: url('charsprite_aurora_luminary'),
  keeper: url('charsprite_keeper'),
}

export function characterSprite(id: string): string | undefined {
  return CHARACTER_SPRITE[id]
}

export const POWERUP_ART: Record<string, string> = {
  shield: url('item_shield_bubble'),
  rewind: url('item_rewind_arrow'),
  hint: url('item_path_hint_compass'),
  magnet: url('item_coin_magnet'),
  slowmo: url('item_slowmo_hourglass'),
  extra_lives: url('item_extra_life_heart'),
  double_coins: url('item_double_coins'),
  invincibility: url('item_invincibility_star'),
  score_multiplier: url('item_score_multiplier_gem'),
  skip_level: url('item_skip_level_portal'),
}

export function powerupArt(id: string): string | undefined {
  return POWERUP_ART[id]
}

export const PRODUCT_ART: Record<string, string> = {
  starter_bundle: url('store_starter_pack'),
  mega_bundle: url('store_whale_bundle'),
  prestige_aurora: url('char_aurora_luminary'),
  skin_pack_aurora: url('char_aurora_luminary'),
  gems_mini: url('currency_gem_single'),
  gems_small: url('currency_gem_cluster_small'),
  gems_large: url('currency_gem_cluster_medium'),
  gems_grand: url('currency_gem_cluster_large'),
  gems_royal: url('currency_gem_cluster_large'),
  coins_small: url('currency_coin_pile_small'),
  coins_large: url('currency_coin_pile_large'),
  remove_ads: url('currency_chest_closed'),
  perm_coin_doubler: url('currency_coin_pile_large'),
  perm_magnet: url('item_coin_magnet'),
}

export function productArt(id: string): string | undefined {
  return PRODUCT_ART[id]
}

export const BIOME_ART: Record<string, string> = {
  forest: url('biome_forest_wide'),
  cave: url('biome_cave_wide'),
  lava: url('biome_lava_wide'),
  ice: url('biome_ice_wide'),
  magical: url('biome_magical_wide'),
  dungeon: url('biome_dungeon_wide'),
}

export function biomeArt(id: string): string | undefined {
  return BIOME_ART[id]
}

export const WORLDMAP_BG = url('ui_worldmap_bg')
export const HOME_DIORAMA_BG = url('ui_home_diorama_bg')
export const DRIFT_ART = url('biome_drift_endless')
export const TITLE_LOGO = url('ui_title_logo_mark')

export const TILE_ART = {
  floor: url('tile_biome_forest'),
  wall: url('tile_wall_block'),
  home: url('tile_home_portal'),
  coin: url('currency_coin_single'),
  gem: url('currency_gem_single'),
  lava: url('tile_hazard_lava_glow'),
  water: url('tile_hazard_water'),
  ice: url('tile_ice'),
  breakable: url('tile_crystal_cracked'),
  key: url('tile_key_rusted'),
  door: url('tile_door_closed'),
  teleport: url('tile_teleport_pad'),
  switch: url('tile_switch_up'),
} as const

export const STORE_BANNER = url('store_hero_banner')

export const CURRENCY_ART = {
  coin: url('currency_coin_single'),
  coinPile: url('currency_coin_pile_medium'),
  gem: url('currency_gem_single'),
  gemPile: url('currency_gem_cluster_medium'),
  chest: url('currency_chest_closed'),
}
